import * as React from "react";
import { ReadOnlyFormGroup } from "components/common";
const DataLakeStatus = ({ dataLakeEnabled }) => /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Enabled", value: dataLakeEnabled || false });
export default DataLakeStatus;
